import type { AuthorizedResourceAccessMap } from '@/permissions/adapter';
import {
  PERMISSION_ACTION_CODES,
  PERMISSION_RESOURCE_CODES,
} from '@/permissions/definitions';

const buildAdminAccessMap = (
  authorizedResourceAccess: AuthorizedResourceAccessMap = {},
): AuthorizedResourceAccessMap => {
  const adminAccessMap: AuthorizedResourceAccessMap = {
    ...authorizedResourceAccess,
  };

  Object.values(PERMISSION_RESOURCE_CODES).forEach((resourceCode) => {
    adminAccessMap[resourceCode] = true;
  });

  Object.entries(PERMISSION_ACTION_CODES).forEach(
    ([resourceKey, resourceActions]) => {
      const resourceCode =
        PERMISSION_RESOURCE_CODES[
          resourceKey as keyof typeof PERMISSION_RESOURCE_CODES
        ];

      Object.values(resourceActions).forEach((actionCode) => {
        adminAccessMap[`${resourceCode}:${actionCode}`] = true;
      });
    },
  );

  return adminAccessMap;
};

/**
 * @see https://umijs.org/docs/max/access#access
 * */
export default function access(
  initialState:
    | {
        authorizedResourceAccess?: AuthorizedResourceAccessMap;
        currentTenantIsAdmin?: boolean;
      }
    | undefined,
) {
  const { authorizedResourceAccess, currentTenantIsAdmin } = initialState ?? {};

  if (currentTenantIsAdmin) {
    return buildAdminAccessMap(authorizedResourceAccess);
  }

  return authorizedResourceAccess || {};
}
